<template>
  <div class="profile-counter" :data-current="current" ref="root">
    <div class="image-wrapper">
      <img src="../assets/images/profile/kachel-01.jpg" alt="">
      <img src="../assets/images/profile/kachel-02.jpg" alt="">
      <img src="../assets/images/profile/kachel-03.jpg" alt="">
    </div>
    <div class="text-wrapper">
      <div class="outer">
        <div class="inner">
          <p class="number"><span class="smaller">#</span>1</p>
          <p>Energiedienstleister in der Region Hannover</p>
        </div>
      </div>
      <div class="outer">
        <div class="inner">
          <p class="number"><span class="smaller">#</span>2</p>
          <p>Energiedienstleister in Niedersachsen</p>
        </div>
      </div>
      <div class="outer">
        <div class="inner">
          <p class="number"><span class="small">Top</span>5</p>
          <p>Energiedienstleister unter deutschen kommunalen Unternehmen</p>
        </div>
      </div>
    </div>
    <div class="icon-wrapper">
      <img src="../assets/images/profile/slide-01.png" alt="">
      <img src="../assets/images/profile/slide-02.png" alt="">
      <img src="../assets/images/profile/slide-03.png" alt="">
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  gsap.registerPlugin(ScrollTrigger);

  export default {
    name: "ProfileCounter",
    data() {
      return {
        current: 0
      }
    },
    mounted() {
      const root = this.$refs.root;
      const t = this;
      gsap.to(root,{
        x: 250,
        scrollTrigger: {
          trigger: root,
          horizontal: window.innerWidth >= 1000,
          scrub: 0,
          scroller: window.innerWidth >= 1000 ? '.scroll-wrapper' : 'body',
          start: window.innerWidth >= 1000 ? 'left 100%' : 'top 85%',
          end: window.innerWidth >= 1000 ? 'right -70%' : 'bottom -70%',
          onUpdate(update) {
            t.current = Math.floor(update.progress * 7 - 0.4);
            if (t.current > 2) {
              t.current = 2;
            }
            if (t.current < 0) {
              t.current = 0;
            }
          }
        }
      });
    }
  }
</script>

<style scoped>
  .profile-counter {
    position: relative;
    display: block;
    width: 540px;
    max-width: 100vw;
    overflow: hidden;
    left: -100px;
    margin-top: 60px;
  }
  @media(max-height: 700px) {
    .profile-counter {
      width: 72vh;
    }
  }
  .profile-counter:after {
    content: "";
    position: relative;
    display: block;
    padding-top: 100%;
    background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
    opacity: 0.8;
  }
  [data-current="0"] img:nth-child(1),
  [data-current="1"] img:nth-child(2),
  [data-current="2"] img:nth-child(3) {
    opacity: 1;
    z-index: 1;
    transition: 0.4s linear 0s;
  }
  .image-wrapper {
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  .image-wrapper img {
    position: absolute;
    display: block;
    object-fit: cover;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: 0s linear 0.4s;
  }
  .text-wrapper, .icon-wrapper {
    position: absolute;
    display: flex;
    flex-direction: row-reverse;
    width: 300%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    transition: 0.4s cubic-bezier(0.45, 0, 0.55, 1);
    transform: translate3d(0, 0, 0);
  }
  .icon-wrapper img {
    max-width: 33.3333%;
    height: auto;
  }
  .icon-wrapper {
    transition: 0.5s cubic-bezier(0.45, 0, 0.55, 1) 0.1s;
  }
  [data-current="0"] .text-wrapper, [data-current="0"] .icon-wrapper {
    transform: translate3d(-66.66667%, 0, 0);
  }
  [data-current="1"] .text-wrapper, [data-current="1"] .icon-wrapper {
    transform: translate3d(-33.33333%, 0, 0);
  }
  .outer {
    position: relative;
    height: 100%;
    flex: 1 1 33.33333%;
    max-width: 33.33333%;
    padding: 5.8%;
  }
  .inner {
    position: relative;
    display: block;
    background-color: #102D61;
    color: #B1D995;
    height: 100%;
    padding: 8% 16% 8% 8%;
    font-size: 22px;
  }
  .number {
    font-size: 140px;
    font-weight: 700;
    line-height: 1;
    margin: 0;
  }
  @media(max-height: 700px) {
    .inner {
      font-size: 3vh;
    }
    .number {
      font-size: 17vh;
    }
  }
  .smaller {
    font-size: 0.7em;
    font-weight: 500;
    margin-left: -0.03em;
  }
  .small {
    font-size: 0.3em;
    font-weight: 500;
    margin-right: 0.1em;
  }
  p {
    margin: 5px 0;
  }
  @media(max-width: 999px) and (min-width: 568px) {
    .profile-counter {
      left: 0;
      transform: none !important;
    }
  }
  @media(max-width: 567px) {
    .profile-counter {
      margin: 30px -20px;
      left: auto;
      width: auto;
      transform: none !important;
    }
    .number {
      font-size: 24vw;
    }
    .inner {
      font-size: 5vw;
    }
  }
</style>